import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";

const WHATSAPP_NUMBER = "528125922909";

export default function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  const scrollToContact = () => {
    const element = document.querySelector("#contact");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      ref={ref}
      className="py-24 lg:py-32 bg-[#050505] relative overflow-hidden"
      data-testid="cta-section"
    >
      {/* Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] lg:w-[600px] h-[400px] lg:h-[600px] bg-[#D4AF37]/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          {/* Overline */}
          <p className="overline mb-6">¿Listo para empezar?</p>

          {/* Main Heading */}
          <h2 className="font-playfair text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-8 leading-tight">
            Hagamos algo{" "}
            <span className="italic text-[#D4AF37]">increíble</span>{" "}
            juntos
          </h2>

          {/* Description */}
          <p className="text-[#A3A3A3] text-base lg:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
            Tu próximo proyecto merece lo mejor. Conversemos sobre cómo podemos
            llevar tu marca al siguiente nivel.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank")}
              className="bg-[#25D366] hover:bg-[#20bd5a] text-white font-manrope font-semibold px-8 py-6 lg:px-10 lg:py-7 rounded-full flex items-center justify-center gap-3 transition-colors duration-200 active:scale-95 text-base lg:text-lg"
              data-testid="cta-whatsapp-btn"
            >
              <MessageCircle size={22} />
              Escríbenos por WhatsApp
            </Button>
            <Button
              onClick={scrollToContact}
              variant="outline"
              className="border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10 font-manrope font-semibold px-8 py-6 lg:px-10 lg:py-7 rounded-full flex items-center justify-center gap-2 transition-colors duration-200 active:scale-95 text-base lg:text-lg"
              data-testid="cta-contact-btn"
            >
              Ver Contacto
              <ArrowRight size={20} />
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
